import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UserFilter } from '../../../../shared/models/lead/userFilter';
import { UserService } from '../../../../shared/services/user/user.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-user-selection-by-role-dropdown',
  templateUrl: '../template-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSelectionByRoleDropdownComponent extends DropdownBaseComponent implements OnInit {

  @Input() isFilterForm: boolean;
  @Input() isPlanDay: boolean;
  @Input() isInCalendar: boolean;
  @Input() loadOnInit = true;
  filter = new UserFilter();

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly userService: UserService,
    protected readonly translatorService: TranslatorService,
    private readonly leadComuService: LeadsComunicationService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.isFilterForm && this.isFilterForm === true) {
      this.filter.visible = true;
    }

    if (this.removeDefaultUnknown) {
      this.itemsData = this.itemsData.filter(item => item.id !== '');
    }
    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection, this.itemsShowLimit, this.userRole, this.isPlanDay);

    if (this.loadOnInit) {
      this.loadUsers();
    }
  }

  loadUsers(): void {

    if (this.isInCalendar) {
      this.userService.usersByRolForCalendarQuery$(null, this.filter, this.isPlanDay).subscribe(res => {
        const listUser = [];
        for (const user of res.userList) {
          listUser.push({ id: user.id, name: `${user.name} ${user.lastName}` });
        }
        this.itemsData = this.itemsData.concat(listUser);
        this.dropdownService.getUserCompleted.emit();
        this.leadComuService.users = res.userList;
      });
    } else {
      this.userService.usersByRolQuery$(null, this.filter, this.isPlanDay).subscribe(res => {
        const listUser = [];
        for (const user of res.userList) {
          listUser.push({ id: user.id, name: `${user.name} ${user.lastName}` });
        }
        this.itemsData = this.itemsData.concat(listUser);
        this.leadComuService.users = res.userList;
        this.dropdownService.getUserCompleted.emit();
      });
    }
  }

}
